import elections from "./elections";

/**
 * Fetch the widget configuration info.
 *
 * @param {string} eventId
 * @param {string} widgetId
 * @returns {Object} The widget configuration
 */
export async function fetchWidgetConfig(eventId, widgetId) {
  const result = await elections.get(`/widgets/${widgetId}/`, {
    params: { eventId }
  });

  return result.data;
}
